import React from 'react';
import AlertMessage from '../../components/alerts';
import JuskAskMain from '../../components/justask'
import TopHeader from '../../components/header';
import LeftPanel from "../../components/leftpanel";

const JuskAsk = () => {

    return (

        <div id="container">
            <TopHeader />
            <div className="sidebar-mini">
                <LeftPanel />
                <div id="message-container">
                    <AlertMessage />
                </div>
                <JuskAskMain />
            </div>
        </div>
    );
}

export default JuskAsk;